<div class="content">
  <h1 class="large">Сброс пароля</h1>

  @if (tokenMissing) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Ссылка недействительна. Запросите восстановление пароля повторно.
    </div>
    <div class="login-link">
      <a routerLink="/forgot-password">Восстановить пароль</a>
    </div>
  } @else {
    @if (error) {
      <div class="common-error">
        <img src="icons/error_icon.png" alt="error">
        Произошла ошибка: {{ error }}
      </div>
    }
    @if (successMessage) {
      <div class="success-message">
        {{ successMessage }}
      </div>
    }
    <form #f="ngForm" (ngSubmit)="save(f)">
      <!-- email -->
      <div>
        <input type="email"
               name="email"
               placeholder="Email"
               class="form-input"
               required
               email
               [(ngModel)]="email"
               #emailInput="ngModel">

        @if (emailInput.invalid && (emailInput.touched || emailInput.dirty)) {
          <div class="error">
            Email не валиден
          </div>
        }
      </div>

      <!-- новый пароль -->
      <div>
        <input type="password"
               name="password"
               placeholder="Новый пароль"
               class="form-input"
               required
               appPasswordValidationDirective
               [(ngModel)]="password"
               #pwd="ngModel">

        @if (pwd.invalid && (pwd.touched || pwd.dirty)) {
          <div class="error">
            Пароль должен быть не меньше 8 символов, содержать символы в разном регистре, спецсимволы и цифры
          </div>
        }
      </div>

      <!-- подтверждение -->
      <div>
        <input type="password"
               name="confirmation"
               placeholder="Подтверждение"
               class="form-input"
               required
               [(ngModel)]="confirmation"
               #conf="ngModel">

        @if (conf.invalid && (conf.touched || conf.dirty)) {
          <div class="error">
            Введите подтверждение пароля
          </div>
        }
        @if (passwordsMismatch && (conf.touched || conf.dirty)) {
          <div class="error">
            Пароль и подтверждение не совпадают
          </div>
        }
      </div>

      <button type="submit"
              class="primary"
              [disabled]="f.invalid || passwordsMismatch || loading || !!successMessage">
        Сохранить
      </button>
    </form>
  }
</div>
